
import { DateTime } from 'luxon';

export default class DateFormat {

	static getDataAtual() {
		return DateTime.now().toFormat('yyyy/LL/dd');
	}

	static getDataAnterior(dias) {
		return DateTime.now().minus({ days: dias }).toFormat('yyyy/LL/dd');
	}

	static getDataPosterior(dias) {
		return DateTime.now().minus({ days: dias }).toFormat('yyyy/LL/dd');
	}

	static getDataHoraAtual() {
		return DateTime.now().toFormat('yyyy/LL/dd HH:mm');
	}

	static getDataHoraAnterior(dias) {
		return DateTime.now().minus({ days: dias }).toFormat('yyyy/LL/dd HH:mm');
	}

	static getDataHoraAnteriorMinutos(minutos) {
		return DateTime.now().minus({ minutes: minutos }).toFormat('yyyy/LL/dd HH:mm');
	}

	static getDataInicioMesAtual() {
		return `${DateTime.now().toFormat('yyyy/LL')}/01`;
	}

	static getTimestampParaData(timestamp) {
		return !timestamp ? null : DateTime.fromMillis(timestamp).toFormat('yyyy/LL/dd');
	}

	static getTimestampParaDataHora(timestamp) {
		return !timestamp ? null : DateTime.fromMillis(timestamp).toFormat('yyyy/LL/dd HH:mm');
	}

	static formatarDataSqlParaTela(data) {
		return !data ? null : (DateTime.fromISO(data).isValid ? DateTime.fromISO(data) : DateTime.fromFormat(data, 'yyyy/LL/dd')).toFormat('dd/LL/yyyy');
	}

	static formatarDataSqlParaTelaAbreviada(data) {
		return !data ? null : (DateTime.fromISO(data).isValid ? DateTime.fromISO(data) : DateTime.fromFormat(data, 'yyyy/LL/dd')).toFormat('dd/LL/yy');
	}

	static formatarDataHoraSqlParaTela(dataHora) {
		return !dataHora ? null : (DateTime.fromISO(dataHora).isValid ? DateTime.fromISO(dataHora) : DateTime.fromFormat(dataHora, 'yyyy/LL/dd HH:mm')).toFormat('dd/LL/yyyy HH:mm');
	}

	static formatarDataSqlParaExcel(dataHora) {
		
		const dataHoraCarregada = dataHora ? DateTime.fromISO(dataHora).isValid ? DateTime.fromISO(dataHora) : DateTime.fromFormat(dataHora, 'yyyy/LL/dd') : null;
		
		if (dataHoraCarregada && dataHoraCarregada.isValid) {
			return dataHoraCarregada.toJSDate();
		}
		
		return null;
	}

	static formatarDataHoraSqlParaExcel(dataHora) {
		
		const dataHoraCarregada = dataHora ? DateTime.fromISO(dataHora).isValid ? DateTime.fromISO(dataHora) : DateTime.fromFormat(dataHora, 'yyyy/LL/dd HH:mm:ss') : null;
		
		if (dataHoraCarregada && dataHoraCarregada.isValid) {
			return dataHoraCarregada.minus({ hour: 3 }).toJSDate();
		}
		
		return null;
	}

	static formatarDataHoraSqlParaTelaAbreviada(data) {
		return !data ? null : (DateTime.fromISO(data).isValid ? DateTime.fromISO(data) : DateTime.fromFormat(data, 'yyyy/LL/dd HH:mm')).toFormat('dd/LL/yy HH:mm');
	}
	static formatarDataHoraSqlParaTelaDiaMes(data) {
		return !data ? null : (DateTime.fromISO(data).isValid ? DateTime.fromISO(data) : DateTime.fromFormat(data, 'yyyy/LL/dd HH:mm')).toFormat('dd/LL HH:mm');
	}

	static formatarDataTelaParaSql(data) {
		return !data ? null : DateTime.fromFormat(data, 'dd/LL/yyyy').toFormat('yyyy/LL/dd');
	}

	static formatarDataHoraTelaParaSql(dataHora) {
		return !dataHora ? null : DateTime.fromFormat(dataHora, 'dd/LL/yyyy HH:mm').toFormat('yyyy/LL/dd HH:mm');
	}

	static formatarDataTelaParaParametro(data) {
		return !data ? null : (DateTime.fromISO(data).isValid ? DateTime.fromISO(data) : DateTime.fromFormat(data, 'dd/LL/yyyy')).toFormat('yyyy-LL-dd');
	}

	static formatarMinutosParaTempo(minutos) {
		if (minutos == null) {
			return null;
		}

		if (minutos <= 0) {
			return 'Agora';
		}

		const dias = Math.floor(minutos / 1440);
		const horas = Math.floor((minutos % 1440) / 60);
		const mins = Math.floor(minutos % 60);

		let texto = '';

		if (dias > 0) {
			texto += `${dias}d `;
		}

		if (horas > 0) {
			texto += `${horas}h `;
		}

		if (mins > 0) {
			texto += `${mins}min`;
		}

		return texto.trim();
	}

	static getPeriodoCompetencia(competencia) {

		const ano = Number(String(competencia).substring(0, 4));
		const mes = Number(String(competencia).substring(4, 6));

		const isBissexto =
			(ano % 4 === 0 && ano % 100 !== 0) ||
			(ano % 400 === 0);

		let dataInicial;
		let dataFinal;

		// FEVEREIRO
		if (mes === 2) {

			dataInicial = new Date(ano, 0, 29);

			// ano normal termina dia 27
			// bissexto termina dia 28
			dataFinal = new Date(
				ano,
				1,
				isBissexto ? 28 : 27
			);

		}
		// MARÇO
		else if (mes === 3) {

			// ano normal inicia 28/02
			// bissexto inicia 29/02
			dataInicial = new Date(
				ano,
				1,
				isBissexto ? 29 : 28
			);

			dataFinal = new Date(ano, 2, 28);

		}
		// DEMAIS MESES
		else {

			dataInicial = new Date(
				ano,
				mes - 2,
				29
			);

			dataFinal = new Date(
				ano,
				mes - 1,
				28
			);
		}

		const formatar = (data) => {

			const yyyy = data.getFullYear();
			const mm = String(data.getMonth() + 1).padStart(2, '0');
			const dd = String(data.getDate()).padStart(2, '0');

			return `${yyyy}-${mm}-${dd}`;
		};

		return {
			data_inicial: formatar(dataInicial),
			data_final: formatar(dataFinal)
		};
	}

}
